/* The Mint Workshop — return after login.

   New customer accounts ignore ?return_url= and land people on the account
   page. So we remember the destination ourselves and go there once signed in.

   Uses a cookie rather than sessionStorage: the login round trip can pass
   through a different origin, and sessionStorage does not reliably survive
   that. A cookie on our own domain does.

   Fails open: no cookie, no match, or any error and nothing happens. */
(function () {
  'use strict';

  var NAME = 'mw_after_login';

  function setCookie(value, minutes) {
    var exp = new Date(Date.now() + minutes * 60000).toUTCString();
    document.cookie = NAME + '=' + encodeURIComponent(value) +
                      ';expires=' + exp + ';path=/;SameSite=Lax';
  }

  function readCookie() {
    var m = document.cookie.match(new RegExp('(?:^|; )' + NAME + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  function clearCookie() {
    document.cookie = NAME + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;SameSite=Lax';
  }

  /* remember where they were going */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-mw-login-intent]');
    if (!a) return;
    var intent = a.getAttribute('data-mw-login-intent');
    if (intent) setCookie(intent, 30);
  });

  /* and send them there once they are back and signed in */
  if (!document.documentElement.hasAttribute('data-mw-signed-in')) return;

  var target = readCookie();
  if (!target) return;

  clearCookie();                                   // clear first: never loop

  if (target.charAt(0) !== '/' || target.charAt(1) === '/') return;  // same-origin only
  if (window.location.pathname === target) return;                    // already there

  window.location.replace(target);
})();
